import { useState } from 'react'
import SearchInput from '@/components/common/SearchInput'
import { FilterIcon, TriangleIcon } from '@/components/icons'
import { getAllStages } from '@/utils/ad-campaigns-helpers'
import { Button } from '@/components/ui/button'

const FUNNEL_STAGE_OPTIONS = getAllStages().map((stage) => ({
    value: stage.id,
    label: stage.name,
}))

const FilterSection = ({
    searchTerm,
    onSearchChange,
    selectedStages,
    handleApplyFilter,
    currentFunnelStage,
    onSelectAll,
    onStageSelection,
    restrictToFunnelStages = []
}) => {
    const [showFilters, setShowFilters] = useState(false)

    const handleOpenFilters = () => setShowFilters(true)
    const handleCancel = () => setShowFilters(false)

    const handleApply = () => {
        handleApplyFilter()
        setShowFilters(false)
    }

    return (
        <>
            {/* Search and Filter Bar */}
            <div className="tw:flex tw:items-center tw:gap-4 tw:mb-1">
                <div className="tw:flex-1">
                    <SearchInput value={searchTerm} onChange={onSearchChange} placeholder="Search by audience name" />
                </div>

                <div className="tw:relative">
                    <button
                        onClick={handleOpenFilters}
                        className={`tw:border tw:border-[#2450BF] tw:px-3 tw:py-[6px] tw:font-medium tw:!rounded-[2px] tw:text-sm tw:cursor-pointer tw:overflow-hidden tw:flex tw:items-center tw:gap-2 ${
                            selectedStages.size > 0 ? 'tw:bg-[#2450BF59]' : 'tw:bg-transparent'
                        }`}
                    >
                        <FilterIcon />
                        <TriangleIcon />
                    </button>

                    {/* Filter Dropdown */}
                    {showFilters && (
                        <div className="tw:absolute tw:top-full tw:right-0 tw:mt-2 tw:bg-[#071727] tw:border tw:border-[#3B5168] tw:rounded-[2px] tw:p-2 tw:min-w-[240px] tw:z-[1000] tw:shadow-[0px_4px_24px_0px_#05111D40]">
                            <p className="tw:pt-1 tw:text-sm tw:text-[#899CBD] tw:!mb-2">Sales Funnel Stages</p>
                            {FUNNEL_STAGE_OPTIONS.filter((stage) =>
                                restrictToFunnelStages.length > 0 ? restrictToFunnelStages.includes(stage.value) : true,
                            ).map((option) => (
                                <div key={option.value} className="tw:mb-1">
                                    <label className="tw:!flex tw:gap-2 tw:items-center tw:py-1 tw:cursor-pointer tw:rounded tw:text-sm">
                                        <input
                                            type="checkbox"
                                            checked={selectedStages.includes(option.value)}
                                            onChange={() => onStageSelection(option.value)}
                                        />
                                        {option.label}
                                        {option.value === currentFunnelStage && (
                                            <span className="tw:ml-2 tw:text-xs tw:text-gray-500">(current)</span>
                                        )}
                                    </label>
                                </div>
                            ))}

                            {/* Cancel and Apply buttons */}
                            <div className="tw:flex tw:gap-2 tw:!mt-4 tw:flex tw:justify-between">
                                <Button variant="secondary" className="tw:h-7" onClick={handleCancel}>
                                    Cancel
                                </Button>
                                <Button onClick={handleApply} className="tw:h-7">
                                    Apply
                                </Button>
                            </div>
                        </div>
                    )}
                </div>

                <Button onClick={onSelectAll} variant="secondary">
                    Select All
                </Button>
            </div>

            {/* Click outside to close filters */}
            {showFilters && (
                <div
                    className="tw:fixed tw:top-0 tw:left-0 tw:right-0 tw:bottom-0 tw:z-[999]"
                    onClick={() => setShowFilters(false)}
                />
            )}
        </>
    )
}

FilterSection.displayName = 'FilterSection'

export { FilterSection }
